export default __webpack_public_path__ + "static/ro_unit_w.3cc4cb252eb87b62645fde15bc36bccc.svg";